<template lang="pug">
.menu
    .menu__mobile-clickblock(@click='close')

    .menu-mobile__wrapper
        ul.menu-mobile__links.show(ref='links')
            li.menu-mobile__links-item(v-for='{link, text, subsections} = item in items', ref='link')
                router-link.menu-text(
                        v-if='!subsections',
                        :to='`/${link}`',
                        :class='{active: currentMenuItemState === "close" && currentRoute(link)}',
                        @click.native='close'
                )
                    span {{text}}

                .menu-mobile__links-item-toggler(
                        v-else,
                        @click='showSub(link)'
                )
                    span {{text}}


        .menu-mobile__sublinks
            div.menu-mobile__sublinks-links(
                    v-for='{link, text, subsections} = item in items',
                    v-if='subsections'
                )
                ul.menu-mobile__sublinks-list(
                    :data-sublink='link',
                    ref='sublink'
                )
                    li.menu-mobile__sublinks-list-item.menu-mobile__sublinks-list-item--back(@click='setDefaultMobileMenu') Назад
                    li.menu-mobile__sublinks-list-item(
                            v-for='{id, text, list, columns, footnote} = item in subsections',
                            :data-listlink='list'
                        )
                        span(v-if='list', @click='showList(list, link)') {{text}}

                        router-link.menu-text(
                            :to='`/${link}${link === "clients" ? "#" : "/"}${id}`',
                            v-if='id !== ""',
                            @click.native='close'
                        )
                            span {{text}}


        div.menu-mobile__lists
            .menu-mobile__lists-links(
                    v-for='{link, text, subsections} = item in items',
                    v-if='subsections'
                )
                .menu-mobile__lists-links-item(
                        v-for='{id, text, list, columns, footnote} = item in subsections',
                        :class='{active: currentSubRoute(id)}'
                    )

                    ul.menu-mobile__list(
                            :data-link='link',
                            :data-list='list',
                            v-if='list',
                            ref='list'
                        )

                        li.menu-mobile__list__item.menu-mobile__list__item--back
                            span.listlink.listlink--back(@click='showSub(link, list)') Назад

                        li.menu-mobile__list__item(
                                v-for='{name, id, category, footnote} = item in submenu[link]',
                                v-if='list === category',
                                :class='{active: currentSubRoute(id)}'
                            )
                            router-link.listlink(
                                :to='`/${link}/${category}/${id}`',
                                v-if='id !== ""',
                                @click.native='close',
                                :class='{active: currentSubRoute(id)}'
                            )
                                span(:class='`link-${id}`') {{name}}
                                sup(v-if='footnote') *

                        li.submenu__footnote(v-if='footnote')
                            sup *
                            span совместное владение

    ul.menu__wrap(:class='{closed: currentMenuItemState !== "close"}')
        li.menu__item(
                v-for='{link, text, subsections} = item in items',
                :data-state='currentMenuItem === link ? currentMenuItemState : "close"',
                :class='{active: currentMenuItemState === "close" && currentRoute(link)}'
            )
            router-link.menu-text(
                    v-if='!subsections',
                    :to='`/${link}`',
                    :class='{active: currentMenuItemState === "close" && currentRoute(link)}',
                    @click.native='close'
                )
                span {{text}}

            .menu__submenu-wrap(
                    v-if='subsections',
                    :data-state='currentMenuItem === link ? currentMenuItemState : "close"',
                    :class='{active: currentRoute(link)}'
            )
                button.menu-text(@click='updateState(link)') {{text}}

                ul.submenu.column(:class='{"column--custom": link === "clients", "column--large": subsections.length > 4}', @click='customClose')
                    li.submenu__item.submenu__item--mobile(
                                v-for='{id, text, list, columns, footnote} = item in subsections',
                                :class='{active: currentSubRoute(id)}'
                    )
                        router-link.menu-text(
                            :to='`/${link}${link === "clients" ? "#" : "/"}${id}`',
                            v-if='id !== ""',
                            @click.native='close'
                        )
                            span {{text}}

                        button.submenu__toggle(
                                v-if='id === ""',
                                :class='{active: currentSubRoute(list), single: checkActualListLength(submenu[link], list)}',
                                @click='submenuLink(link)',
                                :data-submenu='list'
                        )
                                span.menu-text.menu-text--selected {{text}}

                    li.submenu__item(
                            v-for='{id, text, list, columns, footnote} = item in subsections',
                            :class='{active: currentSubRoute(id)}'
                    )
                        router-link.menu-text(
                            :to='`/${link}${link === "clients" ? "#" : "/"}${id}`',
                            v-if='id !== ""',
                            @click.native='close'
                        )
                            span {{text}}

                        .submenu__wrap(
                                v-if='list',
                                data-state='close',
                                :style='columns > 1 && !isMobileVP() ? {columnCount: columns} : ""'
                        )
                            button.submenu__toggle(
                                v-if='id === ""',
                                :class='{active: currentSubRoute(list), single: checkActualListLength(submenu[link], list)}',
                                @click='toggle'
                            )
                                span.menu-text.menu-text--selected {{text}}

                            ul.list
                                li.list__item(
                                        v-for='{name, id, category, footnote} = item in submenu[link]',
                                        v-if='list === category',
                                        :class='{active: currentSubRoute(id)}'
                                )
                                    router-link(
                                        :to='`/${link}/${category}/${id}`',
                                        v-if='id !== ""',
                                        @click.native='close',
                                        :class='{active: currentSubRoute(id)}'
                                    )
                                        span(:class='`link-${id}`') {{name}}
                                        sup(v-if='footnote') *

                                li.submenu__footnote(v-if='footnote')
                                    sup *
                                    span совместное владение

    .menu__custom(v-if='currentRoute("clients") && !isMobileVP()')
        ul.menu__list
            li(v-for='item in clients.subsections')
                router-link(:to='"#" + item.id', v-html='item.text', :class='{current: item.id === currentClient}')
</template>

<script>
import sections from '../assets/data/sections.json';
import assetsData from '../assets/data/assets.json';
import technologiesData from '../assets/data/technologies.json';
import isMobileVP from '../assets/js/isMobileVP.js';

export default {
    name: 'Menu',

    props: {
        closed: Boolean,
        isOpen: Boolean
    },

    data() {
        return {
            items: sections,
            currentMenuItem: '',
            currentMenuItemState: 'close',
            currentClient: '',

            submenu: {
                assets: assetsData,
                technologies: technologiesData.technologies
            }
        };
    },

    computed: {
        clients() {
            return this.items.filter(el => el.link === 'clients')[0];
        }
    },

    watch: {
        currentMenuItemState(to) {
            if (to === 'close') {
                this.$emit('closeFilter');
            }
        },

        closed(to) {
            if (to) return;
            this.close();
        },

        isOpen(to) {
            if (to) return;
            this.close();
        },

        $route(to) {
            if (to.name === 'clients') {
                this.currentClient = to.hash.slice(1);
            }
        }
    },

    mounted() {
        this.submenu.assets.sort((a, b) => {
            const la = a.name.toLowerCase().charCodeAt(0);
            const lb = b.name.toLowerCase().charCodeAt(0);
            const nameA = a.name.toLowerCase(),
                nameB = b.name.toLowerCase();

            if (la > 1071 && lb > 1071) {
                return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            }
            if (la > 1071 || lb > 1071) {
                return nameA > nameB ? -1 : nameA > nameB ? 1 : 0;
            } else {
                return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            }
        });

        this.submenu.technologies.sort((a, b) => {
            const la = a.name.toLowerCase().charCodeAt(0);
            const lb = b.name.toLowerCase().charCodeAt(0);
            const nameA = a.name.toLowerCase(),
                nameB = b.name.toLowerCase();

            if (la > 1071 && lb > 1071) {
                return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            }
            if (la > 1071 || lb > 1071) {
                return nameA > nameB ? -1 : nameA > nameB ? 1 : 0;
            } else {
                return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            }
        });
    },

    methods: {
        currentRoute(link) {
            return this.$route.path.split('/')[1] === link;
        },

        currentSubRoute(link) {
            return this.$route.path.split('/')[2] === link || this.$route.path.split('/')[3] === link;
        },

        updateState(link) {
            this.$emit('openFilter');
            if (this.currentMenuItem === link && this.currentMenuItemState === 'open') {
                this.currentMenuItemState = 'close';
                return;
            }
            this.currentMenuItem = link;
            this.currentMenuItemState = 'open';
        },

        isMobileVP() {
            return isMobileVP();
        },

        close() {
            this.currentMenuItem = '';
            this.currentMenuItemState = 'close';
            this.$emit('close');
            setTimeout(() => {
                this.setDefaultMobileMenu();
            }, 400);
        },

        customClose() {
            if (this.isMobileVP()) return;
            this.close();
        },

        toggle(evt) {
            const parent = evt.target.parentElement;
            parent.setAttribute('data-state', parent.attributes['data-state'].value === 'close' ? 'open' : 'close');
        },

        checkActualListLength(arr, id) {
            return arr.filter(el => el.category === id).length === 1;
        },

        setDefaultMobileMenu() {
            this.$refs.links.classList.add('show');
            this.$refs.sublink.forEach(element => {
                element.classList.remove('show');
            });
            this.$refs.list.forEach(element => {
                element.classList.remove('show');
            });
        },

        showSub(link, list) {
            this.$refs.sublink.forEach(element => {
                if (element.dataset.sublink === link) {
                    element.classList.add('show');
                }
            });
            this.$refs.links.classList.remove('show');

            if (list) {
                this.$refs.list.forEach(element => {
                    if (element.dataset.list === list) {
                        element.classList.remove('show');
                    }
                });
            }
        },

        showList(list, link) {
            this.$refs.list.forEach(element => {
                if (element.dataset.list === list) {
                    element.classList.add('show');
                }
            });
            this.$refs.sublink.forEach(element => {
                element.classList.remove('show');
            });

            this.goToFirstElement(link, list);
        },

        goToFirstElement(id, subId) {
            this.$router
                .push({
                    name: id,
                    params: {
                        id: this.submenu[id].find(el => el.category === subId).id,
                        category: subId
                    }
                })
                .catch(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.menu {
    height: 100%;
    font-family: var(--font-accent);

    @media (--viewport-tablet) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;

        .header[data-menu-state='close'] & {
            opacity: 0;
            pointer-events: none;
        }
    }

    @supports (--css: variables) {
        @media (--viewport-tablet) {
            min-height: calc(var(--vh, 1vh) * 100);
        }
    }

    &__mobile-clickblock {
        display: none;

        @media (--viewport-tablet) {
            background-color: rgba(0, 0, 0, 0.6);
            display: block;
            position: fixed;
            width: 25vw;
            height: 100vh;
            top: 0;
            left: 0;
        }
    }

    &__wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 100%;
        // padding-right: 0.8em;

        @media (--viewport-tablet) {
            display: none;
            background: var(--color-main-bg);
            flex-direction: column;
            justify-content: flex-start;
            padding: calc(var(--layout-column-width) * 3) 0;
            height: auto;
            min-height: 100%;
        }

        &.closed {
            .menu {
                &__item {
                    &:hover,
                    &.active {
                        .menu-text {
                            // color: white;
                        }
                    }
                }
            }
        }
    }

    .menu-text {
        color: var(--color-main-text);
        text-decoration: none;
        font-weight: bold;
        text-transform: uppercase;
        opacity: 1;
        transition: opacity 0.3s ease;
        color: white;

        &::selection {
            background: transparent;
        }

        span {
            &::selection {
                background: transparent;
            }
        }

        @media (--viewport-tablet) {
            color: black;
        }
    }

    .active {
        > span.menu-text,
        > .menu-text,
        &.menu-text {
            opacity: 1;
        }
    }

    &__item {
        position: relative;
        display: flex;
        align-items: center;
        background: #000;
        height: 100%;
        padding: 0.5em 0.8em;

        .menu__submenu-wrap {
            position: relative;
        }

        &:hover {
            background: var(--color-accent-bg);

            .menu-text {
                color: #000;

                &--selected {
                    opacity: 1;
                }
            }
        }

        &.active,
        &.active:hover {
            background: white;

            .menu-text {
                color: #000;

                &--selected {
                    opacity: 1;
                }
            }
        }

        &[data-state='open'] {
            background: var(--color-main-bg);

            button.menu-text {
                color: var(--color-main-text);
            }

            .menu-text {
                color: var(--color-accent-text);
            }

            @media (--viewport-tablet) {
                background: var(--color-main-bg);

                .menu-text {
                    color: var(--color-main-text);
                }
            }
        }

        @media (--viewport-tablet) {
            width: 100%;
            font-size: 7vw;
            height: auto;
            text-transform: none;
            line-height: 1.2;
            padding-left: calc(var(--layout-gutter-width) * 3 + var(--layout-column-width) * 2);
            background: white;

            &.active,
            &:hover {
                background: var(--color-main-bg);

                .menu-text {
                    color: currentColor;
                }
            }
        }
    }

    &__custom {
        width: 100%;
        background-color: var(--color-main-bg);
    }

    &__list {
        display: flex;
        justify-content: center;

        li {
            flex-grow: 1;
        }

        a {
            color: var(--color-main-text);
            font-size: 0.8em;
            display: block;
            width: 100%;
            height: 100%;
            padding: 0.2em 0.8em;
            text-decoration: none;
            text-transform: uppercase;

            &:hover {
                background-color: var(--color-header-bg);
                color: var(--color-accent-text) !important;
            }
        }
    }
}

.submenu {
    position: absolute;
    top: -200%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    padding-top: 1em;

    .router-link-exact-active {
        color: white !important;

        @media (--viewport-tablet) {
            color: black !important;
        }
    }

    @supports (--css: variables) {
        min-height: calc(var(--vh, 1vh) * 100);
    }

    @media (--viewport-tablet) {
        min-height: auto;
    }

    &.column {
        // column-count: 4;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        position: fixed;
        width: 100%;
        padding: 15vh calc(var(--layout-column-width) * 3) 15vh calc(var(--layout-column-width) * 3);

        @media (--viewport-tablet) {
            display: flex;
            justify-content: normal;
            padding: 15vh 0 15vh calc(var(--layout-column-width) + var(--layout-gutter-width));
        }

        &--custom {
            column-count: 4;
            display: block;

            @media (--viewport-tablet) {
                display: flex;
            }
        }
    }

    &.column--large {
        justify-content: flex-start;

        .submenu__item {
            max-width: 25%;
        }
    }

    .menu__submenu-wrap[data-state='open'] & {
        opacity: 1;
        pointer-events: all;
        top: 2.8em;

        .menu-text {
            // color: var(--color-accent-text);

            @media (--viewport-tablet) {
                // color: var(--color-main-text);
            }
        }

        @media (--viewport-tablet) {
            opacity: 1;
            position: relative;
            flex-direction: column;
            pointer-events: all;
            top: 0;
            left: 0;
            padding-top: 0.4em;
            padding-bottom: 0.4em;
            padding-left: 0;
        }
    }

    &__wrap {
        column-gap: var(--layout-gutter-width);
    }

    &__item {
        // flex-grow: 1;
        // text-transform: capitalize;

        span {
            display: inline-block;
            padding: 0.2em 0em;

            &::selection {
                background: transparent;
            }
        }

        &:hover {
            .menu-text {
                color: var(--color-accent-text);
                opacity: 1;

                @media (--viewport-tablet) {
                    opacity: 1;
                    color: black;
                }
            }
        }

        @media (--viewport-tablet) {
            font-size: 0.4348em;
            padding: 0.3em 0;
            margin-bottom: 0;
            display: none;

            a {
                margin-left: calc(var(--layout-gutter-width) + var(--layout-column-width));
                display: block;
            }
        }

        &--mobile {
            display: none;
            @media (--viewport-tablet) {
                display: flex;
            }
        }

        .menu-text {
            text-decoration: none;
            color: var(--color-accent-text);
            opacity: 0.4;
            font-family: var(--font-main);
            font-weight: 400;

            @media (--viewport-tablet) {
                color: var(--color-main-text);
            }

            &:hover,
            &.active {
                opacity: 1;
            }

            &::selection {
                background: transparent;
            }
        }
    }

    &__toggle {
        cursor: default;
        text-align: left;
        padding: 0 0.5em;

        @media (--viewport-tablet) {
            padding: 0.25em 0;
            font-size: 1.4em;
        }

        &.single {
            display: none;

            @media (--viewport-tablet) {
                display: flex;
            }
        }

        span {
            pointer-events: none;
        }

        .menu-text {
            text-transform: uppercase;
            font-family: var(--font-accent);
        }

        @media (--viewport-tablet) {
            display: flex;

            &::before,
            &::after {
                content: '';
                background-color: var(--color-accent-bg);
                flex-shrink: 0;
                margin-top: -0.3em;
            }

            &.active {
                &::before,
                &::after {
                    background-color: var(--color-main-text);
                }
            }

            &::before {
                width: var(--layout-column-width);
                height: 3px;
                margin-right: var(--layout-gutter-width);
                align-self: center;
            }

            &::after {
                height: var(--layout-column-width);
                width: 3px;
                align-self: center;
                order: -1;
                position: relative;
                left: calc(var(--layout-column-width) / 2 + 2px);

                .submenu__wrap[data-state='open'] & {
                    display: none;
                }
            }
        }
    }

    .list {
        padding-bottom: 1em;
        padding-top: 0;
    }

    &__footnote {
        font-size: 0.7em;
        text-decoration: none;
        color: var(--color-accent-text);
        opacity: 0.4;
        font-family: var(--font-main);
        padding: 1em 0.5em 0;

        @media (--viewport-tablet) {
            color: var(--color-main-text);
            padding: 0.5em 0;
            margin-left: calc(var(--layout-gutter-width) + var(--layout-column-width));
        }
    }
}

.menu-mobile {
    &__wrapper {
        display: none;
        align-items: center;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
        padding: calc(var(--layout-column-width) * 3) 0;
        height: auto;
        min-height: 100%;
        background: var(--color-main-bg);
        position: absolute;
        width: 75vw;
        height: 100vh;
        min-height: calc(var(--vh, 1vh) * 100);
        top: 0;
        right: 0;
        overflow: hidden;

        @media (--viewport-tablet) {
            display: flex;
        }
    }

    &__links,
    &__sublinks,
    &__lists {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        padding-left: 15vw;
        padding-top: 10vh;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        pointer-events: none;
    }

    &__links {
        &-item {
            font-size: 2em;
            .menu-text {
                text-transform: capitalize;
                .header[data-menu-state='open'] & {
                    pointer-events: all;
                }
            }
            &-toggler {
                .header[data-menu-state='open'] & {
                    pointer-events: all;
                }
            }
        }
    }

    &__sublinks {
        &-links {
            position: absolute;
            width: 100%;
            height: 100vh;
            top: 0;
            left: 0;
        }

        &-list {
            padding-left: 15vw;
            padding-top: 10vh;

            &-item {
                text-decoration: none;
                color: black;
                font-size: 6vw;
                margin-bottom: 2vw;

                &--back {
                    font-weight: 400;
                    color: var(--color-accent-bg);
                }
            }
        }
    }

    &__lists {
        &-links {
            position: absolute;
            width: 100%;
            height: 100vh;
            top: 0;
            left: 0;

            &-item {
                position: absolute;
                width: 100%;
                height: 100vh;
                top: 0;
                left: 0;

                &--back {
                    font-weight: 400;
                    color: var(--color-accent-bg);
                }
            }
        }
    }

    &__list {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        padding-left: 15vw;
        padding-top: 10vh;
        padding-bottom: 10vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;

        &__item {
            margin-bottom: 2vw;

            .listlink {
                text-decoration: none;
                color: black;
                font-size: 6vw;

                &--back {
                    font-weight: 400;
                    color: var(--color-accent-bg);
                }
            }
        }
    }
}

.menu-mobile__links,
.menu-mobile__sublinks-list,
.menu-mobile__list {
    transition: opacity 0.3s ease-in, transform 0.1s ease-in 0.5s;
    transform: translateX(30vw);
    opacity: 0;

    &.show {
        transition: opacity 0.5s ease-out 0.2s, transform 0.5s ease-out 0.2s;
        transform: translateX(0vw);
        opacity: 1;

        .header[data-menu-state='open'] & {
            pointer-events: all;
        }

        .listlink,
        .menu-mobile__sublinks-list-item,
        .menu-mobile__links-item {
            .header[data-menu-state='open'] & {
                pointer-events: all;
            }
        }
    }
}

.list {
    padding-top: 0.5em;

    @media (--viewport-tablet) {
        flex-direction: column;
        display: flex;
        width: auto;
        height: auto;
        max-height: none;
        flex-wrap: nowrap;

        .submenu__wrap[data-state='close'] & {
            position: absolute;
            top: -200%;
            pointer-events: none;
            opacity: 0;
        }
    }

    &__item {
        padding: 0 0.5em;

        @media (--viewport-tablet) {
            padding: 0.25em 0;
            font-size: 1.4em;
        }

        a {
            text-decoration: none;
            color: var(--color-accent-text);
            opacity: 0.4;
            font-family: var(--font-main);

            @media (--viewport-tablet) {
                color: var(--color-main-text);
            }

            &:hover,
            &.active {
                opacity: 1;
            }

            &::selection {
                background: transparent;
            }
        }
    }
}
</style>
